module.exports = __webpack_public_path__ + "static/media/06.Jambumali with Ravan.15bffe8a.jpg";